<template>
  <div>
    <el-row style="text-align:left">
      <br>
      <el-col :span="24">
        <el-form :inline="true"
                 class="demo-form-inline">

          <el-form-item label="新增组合">
            <el-select @change="seachRelateStock"
                       style="width: 500px"
                       v-model="compareStocks"
                       value-key="ts_code"
                       multiple
                       filterable
                       remote
                       :loading="searchLoading"
                       loading-text="AI正在搜索同行业内相关股票..."
                       :remote-method="searchCompareStock"
                       default-first-option
                       placeholder="请输入2~5只股票名称或代码">
              <el-option-group :label="optionName">
                <el-option v-for="item in compareOptions"
                           :key="item.ts_code"
                           :label="item.name"
                           :value="item"
                           :disabled="compareStocks.length > 4">

                </el-option>
              </el-option-group>
            </el-select>

          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="openCompareDialog(compareStocks,'新建组合')">分析一下</el-button>

          </el-form-item>
        </el-form>

        <template v-for="(item,index) in compareStocks">
          <template v-if="relateStocks[item.symbol]">
            <el-row :key="index">
              {{item.name}}的相关股票:
              <template v-if="relateStocks[item.symbol].length==0">
                暂无
              </template>
              <template v-else>
                <template v-for="i in relateStocks[item.symbol]">
                  <el-link :underline="false"
                           :key="i"
                           @click="compareStocks.push(i)"> {{i.name}}&nbsp;</el-link>
                </template>
              </template>
            </el-row>

          </template>
        </template>

      </el-col>

      <el-col :span="24">
        <h3><i class="iconfont">&#xe66a;</i>&nbsp;&nbsp;历史组合</h3>
        <el-row>

          <template v-if="compareHistory && compareHistory.length>0">
            <template v-for="item in compareHistory">
              <el-card shadow="always"
                       class="compareCard"
                       :key="item.score">
                <el-row>
                  <el-col :span="20">
                    <template v-if="item.value">
                      <!-- {{item.value}} -->
                      <template v-for="index in 5">
                        <template v-if="(index-1) < item.value.length">
                          <div :key="index"
                               style="padding:10px 10px"> {{item.value[index-1].symbol}}【{{item.value[index-1].name}}】</div>
                        </template>
                        <template v-else>
                          <div :key="index"
                               style="padding:10px 10px">&nbsp;</div>
                        </template>
                      </template>
                    </template>

                  </el-col>
                  <el-col :span="4">
                    <div style="clear:both;height:5px"></div>
                    <el-button @click="deleteHistory(item.score)"
                               style="float: right; padding: 3px 0"
                               type="text"><i class="iconfont">&#xe603;</i></el-button>
                  </el-col>
                </el-row>
                <br><br>
                <el-row class="footContainer">
                  <el-col :span="12">
                    <el-button round
                               @click="openCompareDialog(item.value,'历史组合')"
                               class="primaryBtn">快速生成

                      <img src="../../assets/imgs/rightTip.png" />
                    </el-button>
                  </el-col>
                  <el-col :span="12">
                    &nbsp; &nbsp;&nbsp;<i class="iconfont">&#xe606;</i>&nbsp; {{item.score|dateFilter}}
                  </el-col>
                </el-row>
              </el-card>
            </template>
          </template>
          <template v-else>
            <el-col :span="24"
                    style="text-align:center"> <br>
              <img src="../../assets/imgs/compareEmpty.png" /> <br> <br> <br>
            </el-col>

          </template>
        </el-row>
      </el-col>
    </el-row>

    <!--类型选择框-->
    <el-dialog title=""
               width="500px"
               :visible.sync="compareDialogVisible">
      <div class="c_p"
           slot="title"><b>{{(compareStocks.map(f=>{return f.name}).join('-'))||'投资组合'}}</b></div>

      <el-form>
        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="compareFileType"
                      label="PDF">PDF</el-radio>

            <el-radio v-model="compareFileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="compareDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="genCompareReport">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              title=""
              style=" width:100%;height:calc(100vh - 120px);border:0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf()"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import GenDialog from './GenDialog.vue'
export default {
  name: 'compare',
  data: function () {
    return {
      searchStock0001: {},
      stockCode: {},
      reportType: 'SIMPLE',
      fileType: 'PDF',
      options: [],
      candidateOptions: [],
      pdfUrl: '',
      loading: false,
      hotStocks: [],
      pdfDialogVisible: false,
      tabsName: 'concept',
      optionName: '搜索结果',
      openDate: '',
      openHtml: '',
      closeDate: '',
      closeHtml: '',
      curSourceId: '',
      typeDialogVisible: false,

      bkCode: {},
      conceptOptions: [],
      candidateConcept: [],
      conceptUpDlowList: [],

      compareOptions: [],
      compareStocks: [],
      compareHistory: [],
      compareDialogVisible: false,
      compareFileType: 'PDF',

      searchLogs: [],
      curReport: {},

      conceptFileType: 'PDF',

      conceptDialogVisible: false,
      conceptSearchLogs: [],
      top10Stock: {},
      stockScoreType: 'earnging',
      selectDialogVisible: false,

      selectForm: {},
      searchIndustryList: [],
      searchCompanyTypeList: [],
      searchLocationList: [],
      searchConceptList: [],
      searchStocks: [],
      searchLoading: false,
      relateStocks: {},
      searchTimer: null,
      conceptOfStockRes: []
    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    }
  },
  components: {
    GenDialog
  },
  computed: {

  },
  watch: {

  },

  methods: {
    seachRelateStock (item) {
      if (item && item.length > 0) {
        this.searchLoading = true
        let _this = this
        let symbol = item[item.length - 1].symbol
        axios.get('/api/web/stock/searchRelateStocks?stock=' + symbol).then(resp => {
          _this.compareOptions = resp.data
          _this.optionName = 'AI推荐行业内相关股票'
          _this.searchLoading = false
        })
      } else {
        this.compareOptions = []
      }
    },
    deleteHistory (id) {
      let _this = this
      axios.get('/api/web/stock/deleteCompareHistory?id=' + id).then(resp => {
        _this.getCompareHistory()
      })
    },

    openCompareDialog (items, source) {
      if (!items) {
        this.$message.error('请选择2-5只股票')
        return
      }
      if (source) {
        let stocks = []
        this.compareStocks.forEach(i => {
          stocks.push(i.symbol)
        })
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '生成投资组合来源', source])
      }
      if (items.length < 2 || items.length > 5) {
        this.$message.error('请选择2-5只股票')
        return
      }
      this.compareOptions = this.candidateOptions
      this.compareStocks = items
      this.compareDialogVisible = true
    },
    genCompareReport () {
      let _this = this
      let stocks = []
      this.compareStocks.forEach(i => {
        stocks.push(i.symbol)
      })
      this.compareDialogVisible = false
      this.loading = true

      axios.get('/api/web/report/genReport/' + this.compareFileType + '/COMPARE/' + stocks.join()).then(resp => {
        _this.compareDialogVisible = false
        _this.loading = false
        _this.getCompareHistory()
        _this.$alert('任务创建成功,请到我的报告中查看结果', {
          confirmButtonText: '确定'
        })
        // if (resp.data) {

        //   _this.pdfUrl = '/api/web/stock/readPdf/' + resp.data
        //   _this.curSourceId = resp.data
        //   _this.curSourceName = _this.stockCode.ts_code + '.pdf'
        //   _this.pdfDialogVisible = true
        // } else {
        //   _this.$alert('任务创建成功,请到我的报告中查看结果', {
        //     confirmButtonText: '确定'
        //   })
        // }
      }).catch(e => {
        _this.loading = false
        // _this.$message.error(e.msg)
      })
    },

    searchCompareStock (query) {
      query = query.trim()
      if (query !== '') {
        let _this = this
        this.optionName = '搜索结果'
        setTimeout(() => {
          _this.compareOptions = _this.candidateOptions.filter(item => {
            return ((item.name.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              (item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              ((item.pinyin || '').toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.compareOptions = this.searchLogs
      }
    },

    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },
    getCompareHistory () {
      let _this = this
      axios.get('/api/web/stock/compareHistory').then(resp => {
        _this.compareHistory = resp.data
      })
    },
    getSearchLogs (item) {
      let url = '/api/web/stock/searchLogs'
      if (item && item.ts_code) {
        url = url + '?code=' + item.ts_code
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.searchLogs = resp.data
      })
    }

  },

  mounted () {
    let _this = this
    try {
      this.candidateOptions = JSON.parse(localStorage.getItem('candidateOptions'))
    } catch (e) { }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem('candidateOptions', JSON.stringify(_this.candidateOptions))
      _this.loading = false
    })

    this.getCompareHistory()
    this.getSearchLogs()
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/compare.vue